import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { useLoadOptions } from "src/hooks/useLoadOptions";
import { AsyncSelect, ControlledDatePicker, ControlledTextField } from "../../../../../components/forms";
import CardActions from '../../../components/CardActions';
import { SectionBox } from '../../../components/FieldView';
import { OperacionLCSLHPTIFields } from '../types/fields';
import { FormOperacionLCSLHPTI } from '../types/types';
import { useLCSLHPTISectorComercialTipos, useLCSLHPTIUnidadNegocioTipos } from '../hooks/useLCSLHPTICache';
import { SectorComercialFields, UnidadNegocioFields } from 'src/types';
import { UnidadNegocioTipo } from 'src/types/enum/enum';

interface SeccionNuevoLCSLHPTIDatosOperacionProps {
  formMethods: UseFormReturn<FormOperacionLCSLHPTI>
  codSistemaPrincipal: number,
  codSistema: number,
}

const SeccionNuevoLCSLHPTIDatosOperacion = ({
  formMethods,
  codSistemaPrincipal,
  codSistema
}: SeccionNuevoLCSLHPTIDatosOperacionProps) => {
  const { control, resetField, setValue } = formMethods

  const { unidadNegocioTipos, isLoading: loadingUN, isError: errorUN, error: rawErrorUN } = useLCSLHPTIUnidadNegocioTipos(codSistemaPrincipal, codSistema);
  const loadUnidadNegocio = useLoadOptions({
    data: unidadNegocioTipos,
    loading: loadingUN,
    isError: errorUN,
    error: rawErrorUN
  });

  const watchedUnidadNegocio = useWatch({ control, name: OperacionLCSLHPTIFields.CodUnidadNegocio });


    useEffect(() => {
      if (unidadNegocioTipos?.length) {
        const match = unidadNegocioTipos.find(
          (un) => un[UnidadNegocioFields.UnidadNegocioTipo] === UnidadNegocioTipo.SalesAndTrading
        );
        if (match) {
          setValue(OperacionLCSLHPTIFields.CodUnidadNegocio, match[SectorComercialFields.UnidadNegocioCodigo]);
        }
      }
    }, [unidadNegocioTipos, setValue]);
  

  // const { sectorComercialTipos, isLoading: loadingSC, isError: errorSC, error: rawErrorSC } = useLCSLHPTISectorComercialTipos(watchedUnidadNegocio, codSistema);
  // const loadSectorComercial = useLoadOptions({
  //   data: sectorComercialTipos,
  //   loading: loadingSC,
  //   isError: errorSC,
  //   error: rawErrorSC
  // });

  // useEffect(() => {
  //   resetField(OperacionLCSLHPTIFields.CodSectorComercial);
  // }, [watchedUnidadNegocio, resetField]);

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <SectionBox>

        <Grid item xs={12} md={4}>
          <AsyncSelect
            name={OperacionLCSLHPTIFields.CodUnidadNegocio}
            loadOptions={loadUnidadNegocio}
            valueField={SectorComercialFields.UnidadNegocioCodigo}
            control={control}
            label='Unidad de negocio'
            selectNotNulleable
            fullWidth
            disabled
          />
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <AsyncSelect
            name={OperacionLCSLHPTIFields.CodSectorComercial}
            loadOptions={loadSectorComercial}
            valueField={SectorComercialFields.SectorComercialCodigo}
            control={control}
            label='Equipo Comercial'
            selectNotNulleable
            disabled={!watchedUnidadNegocio}
            fullWidth
          />
        </Grid> */}

        <Grid item xs={12} md={4}>
          <ControlledDatePicker
            name={OperacionLCSLHPTIFields.FechaSolicitud}
            control={control}
            label='Fecha Solicitud'
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <ControlledDatePicker
            name={OperacionLCSLHPTIFields.FechaVencimiento}
            control={control}
            label='Fecha Vencimiento'
          />
        </Grid>

        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            name={OperacionLCSLHPTIFields.Observaciones}
            label='Observaciones'
            multiline={true}
            minRows={3}
            fullWidth
          />
        </Grid>
      </SectionBox>
    </CardActions>
  )
}

export default SeccionNuevoLCSLHPTIDatosOperacion;